import { SettingsStateConfigurationService } from 'capability-ng-settings';
import { AppNotificationDelegate } from './app_notification_service';
import { AppStoreBannerComponent } from './appstore_banner/app_store_banner';
import { NewPersonalReminderController } from './create_personal_reminder/create_personal_reminder';
import { PersonalReminderRoutes } from './create_personal_reminder/reminder_routes';
import { AppHeaderComponent } from './header/components/app_header/app_header';
import { STCAPIAdatper } from './core/configs/stc_integration';
import { MyHeaderComponent } from './header/components/my_header/my_header';
import { ApplicationConfigurationModel, ApplicationDetails } from './models/app_config_model';
import { NotificationSettingInfoComponent } from './my_settings/components/notification_settings_info/notification_settings_info';
import { PathPreferencesComponent } from './my_settings/components/path_preferences/path_preferences';
import { NotificationSettingsController } from './my_settings/views/notification_settings/notification_settings_controller';
import { MySettingsRoutes } from './my_settings/routes';
import {
  ResponsiveNavigationComponent,
  ResponsiveNavigationController
} from './responsive_navigation/views/responsive_navigation/responsive_navigation';
import { StartupComponent } from './startup/startup';
import { TOSComponent } from './tos/components/tos/tos';
import { CheckStudentStatusService } from './user_modes/check_student_status_service';
import { UserModesComponent } from './user_modes/user_modes';
import { UserModesService } from './user_modes/user_modes_service';
import { EmailManagementService } from './core/services/email_management_service';
import { Routing } from './core/configs/routing';
import { CapabilityConfigurationService } from './core/services/capability_configuration_service';
import { AboutComponent } from './about/about';
import { MicroNavAp3Controller, MicroNavAp3Directive } from './ap3/components/ap3/ap3';
import { AP3DockRoutes } from './ap3/routes';
import { RedirectAfterPollForSurveyCommand } from 'capability-ng-poll';
import { StudentMenuQuery } from './responsive_navigation/queries/student_menu_query';

import { StringServant } from './global/servants/string_servant';
import { CalendarFacadeService } from './global/servants/calendar_facade';
import { PusherService } from './global/servants/pusher_service';

import './host/host_module';

import './app_notification_service';
import './models/app_config_model';
import './create_personal_reminder/create_personal_reminder';
import './responsive_navigation/views/responsive_navigation/responsive_navigation';
import './my_resources/my_resources_module';
import './my_todos/my_todos_module';

angular
  .module('lib', ['my-resources', 'my-todos', 'host'])
  .factory('ngStringServant', StringServant.build)
  .service('calendarFacade', CalendarFacadeService)
  .service('pusherService', PusherService)
  .run(function settingsStateConfig(ngSettingsStateConfigurationService: SettingsStateConfigurationService) {
    ngSettingsStateConfigurationService.configure({
      favorites: 'my.favorites',
      topics: 'my.settings.path-settings',
      intake: 'intake-poll',
      firstTerm: 'first-term-poll'
    });
  })
  .service('appDetails', ApplicationDetails)
  .provider('appConfigModel', ApplicationConfigurationModel)
  .factory('appNotificationDelegate', (phxNotificationDelegate: any) => {
    return new AppNotificationDelegate(phxNotificationDelegate);
  })
  .controller('NewPersonalReminderController', NewPersonalReminderController)
  .controller('responsiveNavigationController', ResponsiveNavigationController)
  .controller('NotificationSettingsController', NotificationSettingsController)
  .component('responsiveNavigation', new ResponsiveNavigationComponent())
  .component('notificationsSettingsInfo', new NotificationSettingInfoComponent())
  .component('pathPreferences', new PathPreferencesComponent())
  .component('appStoreBanner', new AppStoreBannerComponent())
  .component('userModes', new UserModesComponent())
  .component('startup', new StartupComponent())
  .component('termsOfService', new TOSComponent())
  .component('appHeader', new AppHeaderComponent())
  .component('myHeader', new MyHeaderComponent())
  .component('about', new AboutComponent())
  .service('ngUserModesService', UserModesService)
  .service('ngCheckStudentStatusService', CheckStudentStatusService)
  .service('ngRedirectAfterPollForSurvey', RedirectAfterPollForSurveyCommand)
  .service('ngEmailManagementService', EmailManagementService)
  .service('ngCapabilityConfigurationService', CapabilityConfigurationService)
  .service('ngSTCAPIAdatper', STCAPIAdatper)
  .service('ngStudentMenuQuery', StudentMenuQuery)
  .config(PersonalReminderRoutes)
  .config(MySettingsRoutes)
  .run(Routing)
  .controller('MicroNavAp3Controller', MicroNavAp3Controller)
  .directive('microNavAp3', () => MicroNavAp3Directive)
  .config(AP3DockRoutes);

import './tos/commands/auto_accept_tou_command';
import './tos/commands/decline_tou_command';
import './tos/commands/accept_tou_command';

import './responsive_navigation/commands/load_student_menu_command';
import './responsive_navigation/datasource/student_menu_datasource';
import './header/commands/stop_impersonation_command';
import './issue_notifications';



// WEBPACK FOOTER //
// ./app/lib/main.ts